import type { AssertionSource } from '@deepguide-ai/types'
import { Badge } from '@deepguide-ai/ui/badge'
import { cn } from '@/lib/utils'

const LABELS: Record<AssertionSource, string> = {
  AI: 'AI',
  HUMAN: 'Human',
  SYSTEM: 'System',
  SCANNER: 'Scanner',
}

const STYLES: Record<AssertionSource, string> = {
  AI: 'border-status-purple/30 bg-status-purple-bg text-status-purple-strong',
  HUMAN: 'border-status-green/30 bg-status-green-bg text-status-green-strong',
  SYSTEM: 'border-status-gray/30 bg-status-gray-bg text-status-gray-strong',
  SCANNER: 'border-status-blue/30 bg-status-blue-bg text-status-blue-strong',
}

export function AssertionSourceBadge({
  source,
  className,
}: {
  source?: AssertionSource | null
  className?: string
}) {
  if (!source) return null

  return (
    <Badge
      variant='outline'
      className={cn('h-5 rounded-full px-2 text-[11px] font-medium', STYLES[source], className)}
    >
      {LABELS[source]}
    </Badge>
  )
}
